module.exports = __webpack_public_path__ + "img/map-optimized.518a1346.webp";